import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { AmenitiesGroups } from '../dashboard/listing/constants';

class AmenitiesModal extends Component {
  constructor(props) {
    super(props);

    this.getAmenityGroup = this.getAmenityGroup.bind(this);
    this.getAmenityMap = this.getAmenityMap.bind(this);
    this.addOtherAmenitiesToMap = this.addOtherAmenitiesToMap.bind(this);
  }

  getAmenityGroup(amenity) {
    for (const [key, value] of Object.entries(AmenitiesGroups)) {
      if (value.includes(amenity) || value.includes(`${amenity}*`))
        return key;
    }
    return null;
  }

  getAmenityMap(amenities) {
    const map = {};

    for (const amenity of amenities) {
      const group = this.getAmenityGroup(amenity);
      if (!group)
        continue;
      if (group in map) {
        map[group].push(amenity);
      }
      else {
        map[group] = [amenity];
      }
    }

    this.addOtherAmenitiesToMap(map, amenities);

    return map;
  }

  addOtherAmenitiesToMap = (map, amenities) => {
    const otherGroup = "Others";
    for (const amenity of amenities) {
      if (this.getAmenityGroup(amenity))
        continue;

      if (otherGroup in map) {
        map[otherGroup].push(amenity);
      } else {
        map[otherGroup] = [amenity];
      }
    }
  }

  render() {
    const { amenities, isShowing, onClose } = this.props;

    if (!amenities || !amenities.length)
      return null;

    const amenityMap = this.getAmenityMap(amenities);

    return (
      <div>
        <Modal
          id="show-all-page"
          size="sm"
          show={isShowing}
          aria-labelledby="modal-sm"
          centered
          dialogClassName="remove-modal-dialog modal-dialog-centered"
          contentClassName="remove-modal-content"
        >
          <Modal.Header>
            <Modal.Title id="example-modal-sizes-title-sm" className="modal-title">
              Amenities
            </Modal.Title>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          </Modal.Header>
          <Modal.Body>
            {
              Object.entries(amenityMap).map(entry => {
                return (
                  <div>
                    <div className="category-title"><b>{entry[0]}</b></div>
                    <div className="category-section">
                      <ul className="category-box">
                        {
                          entry[1].map((option) => <li key={option}>{option.replace('*', '')}</li>)
                        }
                      </ul>
                    </div>
                  </div>
                )
              })
            }
            {/* <div className="category-section">
              <ul className="category-box">
                {
                  amenities.map((option) => <li key={option}>{option}</li>)
                }
              </ul>
            </div> */}
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

export default AmenitiesModal;
